import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';

/** Sets the password from a reset or welcome link. The backend ends every session, so the cache follows. */
export function useResetPassword() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.resetPassword,
    meta: { silentError: true },
    onSuccess: () => session.clearSession(queryClient),
  });
}
